import { render, staticRenderFns } from "./BindOld.vue?vue&type=template&id=42699ace&scoped=true&"
import script from "./BindOld.vue?vue&type=script&lang=js&"
export * from "./BindOld.vue?vue&type=script&lang=js&"
import style0 from "./BindOld.vue?vue&type=style&index=0&id=42699ace&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42699ace",
  null
  
)

export default component.exports